import { getCurrentPlanId, getActiveProjects, getNonGuestTeamUsers, getGuestTeamUsers } from './store-service';
import { getPlanById } from '../utils/plan';
import { featureAvailable } from '../services/features-service';

export const getCurrentTeamPlan = () => getPlanById(getCurrentPlanId());

export const getPlanTotalProjects = () => {
    const plan = getCurrentTeamPlan();

    if (!plan || !plan.quota || !plan.quota.projects) {
        return Number.POSITIVE_INFINITY;
    }

    return plan.quota.projects;
}

export const getRemainingProjects = () => {
    const totalPlanProjects = getPlanTotalProjects();

    return totalPlanProjects - getActiveProjects().length;
}

export const canCreateProject = () => {
    const reminingProjects = getRemainingProjects();
    return reminingProjects > 0;
}

export const getRemainingTeamMembers = () => {
    const plan = getCurrentTeamPlan();

    if (!plan || !plan.quota || !('members' in plan.quota) || featureAvailable('unlimitedMembers')) {
        return Number.POSITIVE_INFINITY;
    }

    const teamMembersCount = getNonGuestTeamUsers().length;
    return plan.quota.members - teamMembersCount;
}

export const getRemainingClients = () => {
    const plan = getCurrentTeamPlan();

    if (!plan || !plan.quota || !('clients' in plan.quota)) {
        return Number.POSITIVE_INFINITY;
    }

    const guestsCount = getGuestTeamUsers().length;
    return plan.quota.clients - guestsCount;
}
